import styled from 'styled-components'

export const AlignmentContainer = styled.div`
	display: flex;
	flex-direction: column;
	align-items: center;
`
